export const environment = {
  production: true,
  workerEnabled: true,
  channelsVersion: '2026.1.0.961',
  apiUrl: 'assets/data/appConfig-production.json'
};
